export const METRIC_TITLES: Record<string, string> = {
  ping_latency_avg: 'Latency',
  ping_jitter_avg: 'Jitter',
  ping_packet_loss_pct: 'Packet Loss',
  dns_latency_avg: 'DNS Resolution Latency',
  http_latency_avg: 'HTTP Latency (TTLB)',
  http_status_code: 'HTTP Status Code',
  http_response_size: 'HTTP Response Size',
  pageload_latency_avg: 'Page Load Latency',
  pageload_status_code: 'HTTP Status Code',
  pageload_response_size: 'Page Load Response Size',
  throughput_bandwidth_avg: 'Throughput Bandwidth'
};

export const PING_METRICS = ['ping_latency_avg', 'ping_jitter_avg', 'ping_packet_loss_pct'] as const;
export const DNS_METRICS = ['dns_latency_avg', ...PING_METRICS] as const;
export const HTTP_METRICS = ['http_latency_avg', 'http_status_code', 'http_response_size', ...PING_METRICS] as const;
export const PAGELOAD_METRICS = [
  'pageload_latency_avg',
  'pageload_status_code',
  'pageload_response_size',
  ...PING_METRICS
] as const;
export const THROUGHPUT_METRICS = ['throughput_bandwidth_avg', ...PING_METRICS] as const;
